import { useCallback, useState } from 'react';
import { isAxiosError } from 'axios';
import { apiClient } from 'config/api';
import useCustomerId from './useCustomerId';

interface FilterPartnerTransaction {
  fromDate?: string;
  toDate?: string;
  customerTransactionType?: string;
  movementType?: string;
  idArea?: string;
}

/** Custom hook to manage export all partner transactions  */
const useDownloadPartnerTransactions = () => {
  const [isLoading, setIsloading] = useState(false);
  const [error, setError] = useState<string>();
  const { customerId } = useCustomerId();

  const downloadPartnerTransactions = useCallback(
    async (filters: FilterPartnerTransaction) => {
      setIsloading(true);
      setError(undefined);
      try {
        const filtersDigets = {
          ...(filters.fromDate && { fromDate: filters.fromDate }),
          ...(filters.toDate && { toDate: filters.toDate }),
          ...(!filters.idArea &&
            filters.customerTransactionType === 'ADJUSTMENT_DEBIT' && {
              customerTransactionType: 'ADJUSTMENT',
              movementType: 'DEBIT',
            }),
          ...(!filters.idArea &&
            filters.customerTransactionType === 'ADJUSTMENT_CREDIT' && {
              customerTransactionType: 'ADJUSTMENT',
              movementType: 'CREDIT',
            }),
          ...(!filters.idArea &&
            filters.customerTransactionType &&
            !['ADJUSTMENT_DEBIT', 'ADJUSTMENT_CREDIT'].includes(
              filters.customerTransactionType
            ) && {
              customerTransactionType: filters.customerTransactionType,
            }),
          ...(filters.idArea &&
            filters.customerTransactionType && {
              customerAreaTransactionType: filters.customerTransactionType,
            }),
        };
        const response = await apiClient.get(
          filters.idArea
            ? `/v3/export/partner/transactions/customer/${customerId}/area/${filters.idArea}`
            : `/v3/export/partner/transactions/${customerId}`,
          {
            params: filtersDigets,
            responseType: 'blob',
          }
        );

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Movimientos_saldo.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      } catch (error) {
        if (isAxiosError(error)) {
          setError(error.message);
        }
      } finally {
        setIsloading(false);
      }
    },
    [customerId]
  );

  return { isLoading, downloadPartnerTransactions, error };
};

export default useDownloadPartnerTransactions;
